(() => {
  const handleClick = (event) => {
    const btn = event.currentTarget;
    const gallery = btn.closest('media-gallery');
    if (!gallery) return;

    const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list .thumbnail'));
    if (thumbnails.length === 0) return;

    let currentIdx = thumbnails.findIndex((t) => t.getAttribute('aria-current') === 'true');
    if (currentIdx === -1) currentIdx = 0;

    const dir = btn.classList.contains('ltb-gallery-nav--next') ? 1 : -1;
    const nextIdx = (currentIdx + dir + thumbnails.length) % thumbnails.length;

    event.preventDefault();
    event.stopImmediatePropagation();
    thumbnails[nextIdx].click();
  };

  const bindArrows = (root = document) => {
    root.querySelectorAll('.ltb-gallery-nav').forEach((btn) => {
      if (btn.dataset.ltbBound === 'true') return;
      btn.dataset.ltbBound = 'true';
      btn.addEventListener('click', handleClick, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindArrows());
  } else {
    bindArrows();
  }

  // Re-bind after section reload (theme editor)
  document.addEventListener('shopify:section:load', (e) => bindArrows(e.target));
})();
